// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Profile_wrapper__2NyDN","grid":"Profile_grid__5XaAi"};